module.exports = __webpack_public_path__ + "static/media/40.1380e108.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/40.jpg
// module id = 300
// module chunks = 0